import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=31299514&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=js&"
export * from "./alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31299514",
  null
  
)

export default component.exports